import { Typography } from '@mui/material';
import type { ReactNode } from 'react';

export const GroupTitle = ({
  title,
  hideBackground,
}: {
  title: ReactNode;
  hideBackground?: boolean;
}) => {
  return (
    <Typography
      variant='overline'
      className='w-full cursor-default'
      sx={{
        display: 'block',
        padding: '8px 24px',
        marginY: '12px',
        backgroundColor: hideBackground
          ? undefined
          : 'var(--mui-palette-background-section)',
      }}
    >
      {title}
    </Typography>
  );
};
